import { Box, FlexBox, Spinner } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { Waypoint } from 'react-waypoint';

import { CategorizedListProps } from 'components/categorizedList';

type LoadingItemProps = Pick<
  CategorizedListProps,
  'asyncStatus' | 'hasNextPage' | 'nextPage'
>;

/** Represents a loading item. */
export const LoadingItem = ({
  asyncStatus,
  hasNextPage,
  nextPage,
}: LoadingItemProps): JSX.Element => {
  /** Handles changing to the next page. */
  const handleNextPage = useCallback(() => {
    if (hasNextPage) {
      nextPage();
    }
  }, [hasNextPage, nextPage]);

  return (
    <Box as="li">
      {asyncStatus === 'pending' && (
        <FlexBox justifyContent="center" padding="200 300">
          <Spinner size={20} />
        </FlexBox>
      )}
      {asyncStatus !== 'pending' && <Waypoint onEnter={handleNextPage} />}
    </Box>
  );
};
